import { Col, Row } from 'antd'
import { DatePicker, TimePicker } from 'components/atoms'
import { PLACE_HOLDER_EMPTY } from 'constants/placeholder'
import moment from 'moment'
import { ALL_HOURS } from 'pages/menuWorkingSchedule/constants'
import { useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import {
  formatDate,
  getCurrentDateWithStep,
  getDateAddMinute,
  getDateWithTime
} from 'utils'

const StyledContainer = styled(Row)`
  .ant-col .ant-col {
    padding: 0 !important;
    margin-top: 16px;
  }
`
interface IProps {
  preventInput?: boolean
  value?: { date?: Date; time?: Date }
  minTime?: Date
  minDate?: Date
  minuteStep?: number
  onChange?: (value: { date?: Date; time?: Date }) => void
  required?: boolean
}
enum FormKey {
  Date = 'date',
  FromTime = 'fromTime'
}
const FromDate = (props: IProps) => {
  const {
    preventInput,
    onChange,
    value,
    minTime,
    minDate,
    minuteStep = 30,
    required
  } = props
  const { t } = useTranslation()
  const [time, setTime] = useState<Date | undefined>(undefined)
  const date = useRef(value?.date)
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false)
  const onFieldsChange = (_value: any, fieldName: FormKey) => {
    switch (fieldName) {
      case FormKey.Date:
        const newDate = getDateWithTime(_value, time)
        if (onChange && newDate) {
          onChange({ date: newDate, time: time })
        }
        date.current = _value
        if (onChange) {
          onChange({ date: _value, time: value?.time })
        }
        break
      case FormKey.FromTime:
        setTime(_value)
        const isToday =
          formatDate(new Date(), 'DD/MM/yyyy') ===
          formatDate(date.current || value?.date, 'DD/MM/yyyy')
        const isPastTime =
          isToday && new Date().getTime() > new Date(_value).getTime()

        if (isPastTime) {
          _value = moment(getDateAddMinute(new Date(_value), minuteStep))
        }
        if (_value && (date.current || value?.date)) {
          const newDate = getDateWithTime(date.current || value?.date, _value)
          if (onChange && newDate) {
            onChange({ date: newDate, time: _value })
          }
        }
        break
    }
  }

  const disabledHours = useMemo(() => {
    if (
      value?.date &&
      formatDate(new Date(), 'DD/MM/yyyy') !==
        formatDate(new Date(value?.date), 'DD/MM/yyyy')
    ) {
      return []
    }
    if (minTime) {
      return ALL_HOURS.filter((h) => h < minTime?.getHours())
    }
    return []
  }, [value?.date])
  const handleSetToday = () => {
    const now = new Date()
    const todayTime = getCurrentDateWithStep(30)
    if (onChange && todayTime) {
      onChange({ date: todayTime, time: todayTime })
    }
    date.current = now
    setTime(now)
    setIsDatePickerOpen(false)
  }
  return (
    <>
      <StyledContainer gutter={16}>
        <Col span={12}>
          <DatePicker
            required={required ? required : false}
            title={t('date')}
            placeholder={PLACE_HOLDER_EMPTY}
            preventInput={preventInput}
            value={value?.date ? moment(value?.date) : undefined}
            allowClear={false}
            min={minDate}
            onChange={(value: any) => onFieldsChange(value, FormKey.Date)}
            showToday={false}
            open={isDatePickerOpen}
            onOpenChange={setIsDatePickerOpen}
            renderExtraFooter={() => (
              <h4
                onClick={handleSetToday}
                style={{
                  textAlign: 'center',
                  color: '#65c4a2',
                  cursor: 'pointer',
                  fontWeight: 300
                }}>
                {t('today')}
              </h4>
            )}
          />
        </Col>
        <Col span={12}>
          <TimePicker
            required={required ? required : false}
            inputReadOnly
            preventInput={preventInput}
            format="HH:mm"
            showNow={false}
            minuteStep={minuteStep}
            title={t('time')}
            disabledTime={() => {
              return {
                disabledHours: () => disabledHours
              }
            }}
            value={value?.time ? moment(value?.time) : undefined}
            placeholder={t('select-time')}
            onChange={(value: any) => onFieldsChange(value, FormKey.FromTime)}
            renderExtraFooter={() => (
              <h4
                onClick={handleSetToday}
                style={{
                  position: 'absolute',
                  left: 12,
                  marginTop: 3,
                  color: '#65c4a2',
                  cursor: 'pointer',
                  fontWeight: 300
                }}>
                {t('now')}
              </h4>
            )}
          />
        </Col>
      </StyledContainer>
    </>
  )
}

export default FromDate
